import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ExportPacientesExcel from '../components/ExportPacientesExcel';

export default function ExportPacientesExcelPage() {
  return (
    <DashboardLayout>
      <ExportPacientesExcel />
    </DashboardLayout>
  );
}
